module.exports = __webpack_public_path__ + "static/GlitchlessSonyax52-4e945ec3797d3ff90152b0edddfd595a.png";